import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_GET_LISTING_BY_ID,
  SR_API_ACTION_ADD_USER_BOOKMARK,
} from 'api/actionTypes';

import {
  DATA_TABLE_SOURCE_USER_BOOKMARKS,
} from 'common/dataTableConstants';

import { actionDataTableReset } from 'client/helpers/dataTables';
import analytics from 'client/analytics';
import { ANALYTICS_EVENT_LISTING_BOOKMARKED } from 'client/analytics/eventList';
import {
  makeListingApplicationContext,
} from 'client/analytics/makeApplicationContext';
import askForMobileAppReview from 'client/actions/MobileApp/askForReview';

import { full as fullListingFieldgroup } from 'server/models/Listing/fieldgroups';

export default async function addBookmark({ state, apiClient }, { listingId, userId }) {
  typeCheck('listingId::PositiveNumber', listingId);
  typeCheck('userId::Maybe PositiveNumber', userId);

  const listing = await apiClient.post(SR_API_ACTION_GET_LISTING_BY_ID, {
    listingId: listingId,
    fieldgroup: fullListingFieldgroup,
  });

  if (!state.exists(['bookmarksByListingId', listingId])) {
    const newBookmarksByListingId = {
      ...state.get(['bookmarksByListingId']),
      [listingId]: true,
    };
    state.set(['bookmarksByListingId'], newBookmarksByListingId);
    state.apply(['newBookmarksCount'], (count) => count + 1);
    state.commit();

    await apiClient.postWithState({
      action: SR_API_ACTION_ADD_USER_BOOKMARK,
      state: state,
      payload: {
        listingId,
        userId: userId || state.get(['currentUser', 'id']),
      },
      onSuccess() {
        analytics.track(
          ANALYTICS_EVENT_LISTING_BOOKMARKED,
          makeListingApplicationContext(listing),
        );
        if (Object.keys(newBookmarksByListingId).length === 5) {
          askForMobileAppReview({ state });
        }
      },
    });
  }

  return actionDataTableReset({ state, apiClient }, {
    dataSource: DATA_TABLE_SOURCE_USER_BOOKMARKS,
  });
}
